// extracted by mini-css-extract-plugin
export default {"container":"InfoCard_container__NzdbB","dark":"InfoCard_dark__dms7a","title":"InfoCard_title__PxqO3"};